export const areaNav = () => {
    $(document).ready(function () {

        // Nav active link handling
        $(function () {
            var current = location.pathname;
            $('.areaNav a').each(function () {
                var $this = $(this);
                if (window.location.pathname.length <= 1) {
                } else if ($this.attr('href').indexOf(current) !== -1) {
                    $this.find(".active").addClass('visited');
                }
            })
        })

    });
}
